import { RightFloatingButtonScalor } from "../../editor_common_components";
import { Button } from "../../../core/components/button";
import { Dialog, DialogProps } from "../../../core/components/dialog";
import { TextBox } from "../../../core/components/textBox";
import { FAIcon } from "../../../core/components/faIcon";
import CRTagsGrid from "../../../crReport/crTagsGrid";
import { Grid } from "../../../core/components/grid";
import HttpDocumentsService from "../../../documents/http_document_service";
import { DocumentListItem } from "../../../documents/documents";
import { JsonResultClass } from "../../../core/util/httpManager";
import React from "react";
export class DocumentsPicker extends React.Component<{ onTextChange: any, value: string, label: string, customProps: { getDocumentsFunction } }, { showDialog: boolean }>{
    constructor(props) {
        super(props);
        this.state = { showDialog: false };
    }

    handleSave = (name) => {
        this.setState({ showDialog: false });
        this.props.onTextChange(name);
    }

    render() {
        const dialog = this.state.showDialog ? <DocumentsPickerDialog
            value={this.props.value || []}
            getDocumentsFunction={this.props.customProps.getDocumentsFunction}
            onClose={() => this.setState({ showDialog: false })}
            onSave={this.handleSave}></DocumentsPickerDialog> : null;
        return (
            <li>
                {dialog}
                <div title={this.props.label}>
                    <span className="property-name">
                        <RightFloatingButtonScalor>
                            <Button iconName="edit" title="Edit" handleClick={() => this.setState({ showDialog: true })}></Button>
                        </RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>
                        {this.props.value}
                    </div>
                </div>
            </li>
        );
    }
};

export class DocumentsPickerDialog extends React.Component<{ onSave, onClose, value, getDocumentsFunction }, { documents: DocumentListItem[] }> {
    private entity: any;
    private documentsService = new HttpDocumentsService();
    private gridOptions;
    private dialogProps: DialogProps = {
        title: "Select documents",
        actions: [
            {
                label: "Cancel",
                action: () => {
                    this.props.onClose();
                    return true;
                }
            }],
        afterClose: () => {
        },
        width: 500,
        open: true
    }

    constructor(props) {
        super(props)
        this.entity = {};
        this.state = { documents: null };
        this.gridOptions = this.getGridOptions();
    }

    async componentDidMount() {

        const docs: JsonResultClass<DocumentListItem[]> = await this.props.getDocumentsFunction();
        if (docs.Data) {
            this.setState({ documents: docs.Data });
        }
    }

    customGridFunction = (params) => {
        return <a onClick={() => { this.props.onSave(params.Isguid) }}>{params.FileName}</a>
    }

    private getGridOptions = () => {
        const gridOptions = {
            "sortable": true,
            "pageable": false,
            "groupable": false,
            "filterable": true,
            "selectable": true,
            "resizable": true,
            "scrollable": true,
            "columns": [
                {
                    "field": "FileName",
                    "title": "File name",
                    "reactTemplate": this.customGridFunction,
                    "width": 80
                }
            ]
        };
        return gridOptions;
    }

    renderIfLoaded = () => {
        if (!this.state.documents) {
            return null;
        }
        else {
            return <Dialog {...this.dialogProps}>
                <div style={{ height: "300px" }}>
                    <Grid id="TemplateEditorDocumentPickerGrid" options={this.gridOptions} data={this.state.documents}>
                    </Grid>
                </div>
            </Dialog>
        }
    }

    render() {
        return this.renderIfLoaded();
    }
};